export default "__VITE_ASSET__170feeef__"